import { type LocationContent } from "@/components/location-page";
import { FEES, FIRM } from "@/lib/firm";

export const CONTENT: LocationContent = {
  slug: "meridan-plains",
  name: "Meridan Plains",
  title: "Meridan Plains conveyancing, wills and estates",
  metaTitle: `Meridan Plains Conveyancing & Wills Lawyers | ${FIRM.name}`,
  description: `Fixed-fee Meridan Plains conveyancing — sales ${FEES.sale} incl. GST, purchases ${FEES.purchase}. New builds, wills, powers of attorney and estates. Call ${FIRM.phone}.`,
  lead: "Meridan Plains is a growth suburb of newer estates, house and land packages and young families — with acreage and rural-residential blocks along the western edge that behave nothing like a standard suburban conveyance.",
  paragraphs: [
    "We act for Meridan Plains buyers and sellers on fixed fees from Golden Beach. New estate purchases usually involve an off-the-plan or house and land contract, which means sunset dates, disclosure obligations, staged titling and a builder's contract sitting alongside the land contract. Those are the terms that cause trouble later, so we review them before you sign.",
    "On acreage and rural-residential lots, the issues shift: bore or tank water, on-site septic or treatment systems, bushfire and vegetation overlays, and access easements. Each needs a specific search rather than the standard suburban set.",
    "Young families buying here are also the group least likely to have a will. If you have children, a will that appoints a guardian and a testamentary trust is worth doing while you are already dealing with us on the purchase.",
  ],
  localNotes: [
    {
      t: "Off-the-plan and house and land",
      d: "Sunset dates, permitted variations, staged titling and deposit protection all need checking. We tell you what the developer can change without your consent.",
    },
    {
      t: "New build and builder contracts",
      d: "The land contract and the building contract are separate documents with separate risks. Progress payments, delays and defects liability sit in the building contract.",
    },
    {
      t: "Acreage and rural-residential",
      d: "Water supply, effluent disposal, bushfire overlays, vegetation clearing limits and access easements are the searches that matter on larger lots.",
    },
    {
      t: "Wills for young families",
      d: "Appointing a guardian for children and holding gifts in trust until they are old enough is the core of a family will. Superannuation and life insurance need separate nominations.",
    },
  ],
  suburbs: ["Little Mountain", "Caloundra West", "Aroona", "Currimundi", "Baringa", "Caloundra"],
  faqs: [
    {
      q: "What should I check in an off-the-plan contract at Meridan Plains?",
      a: "The sunset date and who can terminate on it, the developer's right to vary the plan and lot dimensions, the disclosure statement, when the deposit is released, and the settlement trigger once the plan registers. A material variation may give you a right to terminate — but only if you act in time.",
    },
    {
      q: "Do I pay transfer duty on a house and land package?",
      a: "On a two-contract package, transfer duty is generally assessed on the land value only, with the building contract separate. On a single-contract turnkey purchase, duty is usually assessed on the whole price. We confirm which structure you are in before you sign.",
    },
    {
      q: "Do I need a will if I have young children?",
      a: "Yes. Without one, the intestacy rules decide who receives your estate and the court decides guardianship without your stated wishes. A simple family will appoints guardians, appoints an executor and holds children's entitlements in trust until a chosen age.",
    },
  ],
};
